import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { BusinessStatistics } from 'src/app/types/invoicing/reporting/BusinessStatistics';
import type {
  InvoicesInPeriodResponse,
  SalesInPeriodResponse,
  MarginInPeriodResponse,
  TotalStatisticsResponse, TotalStatisticsDto,
  BusinessStatisticsResponse,
  WIPAmountResponse,
} from 'src/app/api-client';

const apiUrl = environment.CalystaApiBaseURL;

@Injectable({
  providedIn: 'root',
})
export class SalesAnalyticsService {
  constructor(private http: HttpClient) {}

  public getBaseUrl = () => `${apiUrl}api/Invoice`;

  public getInvoicesByPeriod = (StartDate: string, EndDate: string): Observable<number> => {
    const params = new HttpParams().set('StartDate', StartDate).set('EndDate', EndDate);
    return this.http
      .get<InvoicesInPeriodResponse>(`${apiUrl}api/Invoice/InvoiceHeader/InvoicesInPeriod`, { params })
      .pipe(map((data) => data.InvoiceCount ?? 0));
  };

  public getSalesByPeriod = (StartDate: string, EndDate: string): Observable<number> => {
    const params = new HttpParams().set('StartDate', StartDate).set('EndDate', EndDate);
    return this.http
      .get<SalesInPeriodResponse>(`${apiUrl}api/Invoice/InvoiceHeader/SalesInPeriod`, { params })
      .pipe(map((data) => data.Sales ?? 0));
  };

  public getMarginByPeriod = (StartDate: string, EndDate: string): Observable<number> => {
    const params = new HttpParams().set('StartDate', StartDate).set('EndDate', EndDate);
    return this.http
      .get<MarginInPeriodResponse>(`${apiUrl}api/Invoice/InvoiceHeader/MarginInPeriod`, { params })
      .pipe(map((data) => data.Margin ?? 0));
  };

  public getMarginToRealized(StartDate: string, EndDate: string, SalesBudgetId: number = null): Observable<TotalStatisticsDto[]> {
    let params = new HttpParams().set('StartDate', StartDate).set('EndDate', EndDate);
    if (SalesBudgetId) {
      params = params.set('SalesBudgetId', SalesBudgetId.toString());
    }
    return this.http
      .get<TotalStatisticsResponse>(`${apiUrl}api/Invoice/SalesDashboardView/TotalStatistics`, { params })
      .pipe(map((data) => data.Data ?? []));
  }

  public getTargetsByBusiness(StartDate: string, EndDate: string): Observable<BusinessStatistics[]> {
    const params = new HttpParams().set('StartDate', StartDate).set('EndDate', EndDate);
    return this.http
      .get<BusinessStatisticsResponse>(`${apiUrl}api/Invoice/SalesDashboardView/BusinessStatistics`, { params })
      .pipe(map((data) => (data.Data ?? []) as unknown as BusinessStatistics[]));
  }

  public getWIPMarginAmount(): Observable<WIPAmountResponse> {
    return this.http.get<WIPAmountResponse>(`${apiUrl}api/Invoice/WIP/Amount`);
  }
}
